import React from 'react'
import { Switch, Route } from 'react-router-dom'
import EditStoreContainer from '../containers/editStoreContainer'
import showStore from '../components/Store/showStore'
import PaymentSettingsContainer from '../containers/paymentSettingsContainer'
import NotificationSettingsContainer from '../containers/notificationSettingsContainer';
import AuthSettings from '../components/Store/authSettings'

export default ({ match }) => (
  <Switch>
    <Route path={`${match.path}/general-settings`} component={EditStoreContainer} />
    <Route path={`${match.path}/payment-settings`} component={PaymentSettingsContainer} />
    <Route path={`${match.path}/notification-settings`} component={NotificationSettingsContainer} />
    <Route path={`${match.path}/auth-settings`} component={AuthSettings} />
    <Route path={`${match.path}`} component={showStore} />
  </Switch>
)
